import React, { useEffect, useState } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/core-plugin-api';

export const SelectExtension = ({
  onChange,
}: FieldExtensionComponentProps<string>) => {
  const catalogApi = useApi(catalogApiRef);
  const [groups, setGroups] = useState<string[]>([]);

  const prefixes = ['dh_vs', 'dh_plt', 'dh_cop'];

  useEffect(() => {
    const fetchGroups = async () => {
      const entities = await catalogApi.getEntities({
        filter: { kind: 'Group' },
      });
      const filtered = entities.items
        .map(e => e.metadata.name)
        .filter(name => prefixes.some(prefix => name.startsWith(prefix)));
      setGroups(filtered);
    };
    fetchGroups();
  }, [catalogApi]);

   const handleChange = (event: SelectChangeEvent<unknown>) => {
    onChange(`group:default/`.concat(event.target.value as string));
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="domain-select-label">Domain</InputLabel>
      <Select
        labelId="domain-select-label"
        label="Domain"
        onChange={handleChange}
      >
        {groups.map(group => (
          <MenuItem key={group} value={group}>
            {group}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
